import React from "react";
import ReactApexChart from "react-apexcharts";

const DoughnutChart = (props) => {
  
  const data = props.data;

  let sumMarketing = 0
  let sumAuthentication = 0; 
  let sumService = 0;
  let sumUtility = 0;
  let sumUnknown = 0;

  for(let i =0; i<data.length; i++){
    switch (data.at(i).message_type){
      case "Marketing":
        sumMarketing ++;
        break;
      case "Authentication":
        sumAuthentication ++;
        break;
      case "Service":
        sumService ++;
        break;
      case "Utility":
        sumUtility ++;
        break;
      default:
        sumUnknown ++;
        break;
    }
  }
  
  const dummyData = [sumUtility, sumMarketing, sumAuthentication, sumService, sumUnknown];

  const chartOptions = {
    labels: ["Utility", "Marketing", "Authentication", "Services", "Unkown Type"],
    colors: ["#ffb400", "#d2980d", "#a57c1b", "#786028", "#9080ff"],
    title: {
      text: 'Message Categories',
      align: 'left',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontWeight: 'bold',
        color: '#000000',
        fontSize: '20px', // Adjust the font size as needed
        fontFamily: 'Helvetica, Arial, sans-serif', // Set to Helvetica and fallback to Arial and generic sans-serif
      },
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      position: "bottom",
      labels: {
        colors: '#000000', // Set the font color for the legend text
        fontSize: "12px"
      },
    },    
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <div id="chart">
      <ReactApexChart
        options={chartOptions}
        series={dummyData}
        type="donut"
        height={400}
      />
    </div>
  );
};

export default DoughnutChart;
